import { render, staticRenderFns } from "./RejectModal.vue?vue&type=template&id=25ee5f40&scoped=true&"
import script from "./RejectModal.vue?vue&type=script&lang=ts&"
export * from "./RejectModal.vue?vue&type=script&lang=ts&"
import style0 from "./RejectModal.vue?vue&type=style&index=0&id=25ee5f40&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ee5f40",
  null
  
)

export default component.exports